import { FC } from 'react'
import Layout from 'components/layout/Layout'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { EncyclopediaSubCategoryProps as Props } from 'features/encyclopedia/types'
import EncyclopediaSubCategory from 'features/encyclopedia/sub-category/EncyclopediaSubCategory'
import { getEncyclopediaArticlesByQuery, getEncyclopediaSubCategories, getEncyclopediaSubCategoryBySlug } from 'api/encyclopedia'

const EncyclopediaSubCategoryPage: FC<Props> = (props) => {
  return (
    <Layout>
      <EncyclopediaSubCategory {...props} />
    </Layout>
  )
}

export const getStaticProps = async ({ params, locale }) => {
  const { subCategory: subCategorySlug } = params

  const [subCategory, relatedArticles] = await Promise.all([
    getEncyclopediaSubCategoryBySlug(subCategorySlug),
    getEncyclopediaArticlesByQuery(subCategorySlug, 'filters[subCategory][slug][$eq]')
  ])

  if (!subCategory) {
    return {
      notFound: true
    }
  }

  return {
    props: {
      articles: relatedArticles,
      subCategory,
      ...(await serverSideTranslations(locale))
    },
    revalidate: 10 // re-generate page when a request comes in, once every 10 seconds
  }
}

export const getStaticPaths = async () => {
  const subCategoryPaths = []

  const subCategories = await getEncyclopediaSubCategories()

  subCategories.forEach((subCat) => {
    const subCatPaths = [
      { params: { subCategory: subCat.slug, category: subCat.category.slug }, locale: 'nl' }
      // { params: { subCategory: subCat.slug, category: subCat.category.slug }, locale: 'fr' }
    ]

    subCategoryPaths.push(...subCatPaths)
  })

  return {
    paths: subCategoryPaths,
    fallback: 'blocking' // will server-render pages on-demand if the path does not exist
  }
}

export default EncyclopediaSubCategoryPage
